import React from "react";

export const FormFieldWrapper = ({ label, description, children }) => (
  <div>
    <div className="text-md text-gray-950 pl-1">{label}</div>
    {children}
    <div className="text-sm text-gray-600 -mt-0.5 pl-1">{description}</div>
  </div>
);
